
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 60 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M38.014 21.17c.867 4.91-2.824 9.593-8.014 9.593-5.188 0-8.88-4.682-8.013-9.594l1.686-8.688 3.615 1.53L30 5.858l2.713 8.153 3.615-1.53 1.686 8.688zM30 16.631a5.885 5.885 0 00-5.887 5.888A5.895 5.895 0 0030 28.408a5.895 5.895 0 005.888-5.888A5.895 5.895 0 0030 16.632zm4.71 5.886a4.716 4.716 0 01-4.71 4.71 4.716 4.716 0 01-4.71-4.71 4.708 4.708 0 014.71-4.71 4.716 4.716 0 014.71 4.71z","fill":"#E7E5EC"}})])
          )
        }
      }
    